export default __webpack_public_path__ + "static/media/e_wdt_c_0_1_2.c955175c.mp3";